export default "__VITE_ASSET__1Rmn3Yhb__"